import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

import { NOTE_REMINDER_FRAGMENT } from '../fragment';

const QUERY = gql(
  `
    mutation CreateNoteReminder(
      $createNoteReminderData: CreateNoteReminderInput!
    ) {
      createNoteReminder(createNoteReminderData: $createNoteReminderData) {
        ...NoteReminderFields
      }
    }
  `,
  [NOTE_REMINDER_FRAGMENT]
);

export type Args = VariablesOf<typeof QUERY>['createNoteReminderData'];

export const mutationFn = async ({
  customMessage,
  deliveryDate,
  eventBasedReminder,
  noteId,
  userTimezone,
}: Args) => {
  const { createNoteReminder, errors } = await gqlClient.request(QUERY, {
    createNoteReminderData: {
      customMessage,
      deliveryDate,
      eventBasedReminder,
      noteId,
      userTimezone,
    },
  });

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return createNoteReminder;
};
